import { useState, useEffect, useContext } from 'react'
import { useFormik } from "formik"
import { FaPlus, FaPen, FaTrash } from "react-icons/fa";
import axios from 'axios'
import * as Yup from "yup"
import ContextStates from '../../context/ContextStates'
import { Url } from '../Url'

const FEditCliente = () => {
    const [addDomicilio, setAddDomicilio] = useState(false)
    const [newDomicilio, setNewDomicilio] = useState('')
    const [newObservaciones, setNewObservaciones] = useState('')
    const { clienteSelected, setViewOpen, setFormView, cliente, modify, setModify, setCliente, editCliente, setEditCliente, domicilioSelected, setDomicilioSelected } = useContext(ContextStates);

    const formik = useFormik({
        initialValues: {
            apellido: clienteSelected.apellido,
            nombre: clienteSelected.nombre,


            telefono: clienteSelected.telefono
        },
        validationSchema: Yup.object({
            apellido: Yup.string()
                .required("El apellido es necesario"),
            nombre: Yup.string()
                .required("El nombre es necesario"),
            domicilio: Yup.string(),
            telefono: Yup.string()

        }),
        onSubmit: async (valores, { resetForm }) => {
            const formData = new FormData()
            formData.append('id', clienteSelected.id);
            formData.append('email', clienteSelected.email);
            formData.append('apellido', valores.apellido);
            formData.append('nombre', valores.nombre);
            formData.append('telefono', valores.telefono);
            try {
                const response = await axios({
                    url: Url + 'api/clientesSet.php',
                    method: 'POST',
                    data: formData,
                })
                setCliente(response.data.results)
                localStorage.setItem('localClient', JSON.stringify(response.data.results))
                setEditCliente(false)
                /*let aux = modify + 1;
                setModify(aux);*/
                setViewOpen(false)
            } catch (e) {
                console.log(e)
            }
        }
    });

    const saveDomicilio = async () => {
        if (newDomicilio!=='') {
            const formData = new FormData()
            formData.append('id', clienteSelected.id);
            formData.append('domicilio', newDomicilio);
            formData.append('observaciones', newObservaciones);
            try {
                const response = await axios({
                    url: Url + 'api/addDomicilio.php',
                    method: 'POST',
                    data: formData,
                })
                setCliente(response.data.results)
                localStorage.setItem('localClient', JSON.stringify(response.data.results))
                setAddDomicilio(false)
            } catch (e) {
                console.log(e)
            }
        }
    }

    const setActual = async(actual) => {
        const formData = new FormData()
        formData.append('id', clienteSelected.id);
        formData.append('iddomicilio', actual);        
        try {
            const response = await axios({
                url: Url + 'api/setActual.php',
                method: 'POST',
                data: formData,
            })
            console.log("response ",response)
            localStorage.setItem('localClient', JSON.stringify(response.data.results))
            setCliente(response.data.results)
            setAddDomicilio(false)
        } catch (e) {
            console.log(e)
        }
    }
    
    const setDomicilio = (item, act) => {
        setDomicilioSelected(item)
        setFormView(act)
        setViewOpen(true)
    }

    return (
        <form
            className="w-full p-0 sm:p-5 rounded-2xl"
            onSubmit={formik.handleSubmit}
        >
            <div className="transition-all w-full sm:p-3">
                <h2 className='text-xl md:text-3xl uppercase mb-3 text-center'>Editar datos de Cliente</h2>
                <div className='flex'>
                    <div className="sm:items-start sm:w-1/2 w-full mr-1">
                        <label htmlFor="apellido" className="block mt-5 text-gray-600 uppercase font-bold">Apellido</label>
                        <input
                            className="py-2 px-3 w-full rounded border border-gray-600"
                            id="apellido"
                            placeholder="Ingrese el apellido"
                            type="text"
                            value={formik.values.apellido}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            autoFocus
                        />
                        {formik.touched.apellido && formik.errors.apellido ? (
                            <div className='w-full block mb-2 text-red-500'>
                                <p>{formik.errors.apellido}</p>
                            </div>
                        ) : null}
                    </div>
                    <div className="sm:items-start sm:w-1/2 w-full ml-1">
                        <label htmlFor="nombre" className="block mt-5 text-gray-600 uppercase font-bold">Nombre</label>
                        <input
                            className="py-2 px-3 w-full rounded border border-gray-600"
                            id="nombre"
                            placeholder="Ingrese el nombre"
                            type="text"
                            value={formik.values.nombre}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.nombre && formik.errors.nombre ? (
                            <div className='w-full block mb-2 text-red-500'>
                                <p>{formik.errors.nombre}</p>
                            </div>
                        ) : null}
                    </div>
                </div>
                <div className="sm:items-start mt-5">
                    <p className="block mt-5 text-gray-600 uppercase font-bold">Domicilios</p>
                    {cliente.domicilios && cliente.domicilios.map((item, index) => (
                        <div key={index} className="radio my-3 flex">
                            <label>
                                <input
                                    type="radio"
                                    name="domicilio"
                                    value={item.id}
                                    checked={item.actual === '1'}
                                    onChange={() => setActual(item.id)}
                                    className='mr-5'
                                />
                                {item.domicilio}
                            </label>
                            <button
                                type="button"
                                className={`p-2 ml-2 text-white transition-all uppercase font-bold rounded-full bg-gray-500 hover:bg-gray-400`}
                                onClick={() => setDomicilio(item, 210)}
                            >
                                <FaPen />
                            </button>
                            <button
                                type="button"
                                className={`p-2 ml-2 text-white transition-all uppercase font-bold rounded-full bg-red-500 hover:bg-red-400`}
                                onClick={() => setDomicilio(item, 211)}
                            >
                                <FaTrash />
                            </button>
                        </div>
                    ))}
                    {addDomicilio ? (
                        <div className="sm:items-start mt-5">
                            <label htmlFor="domicilio" className="block text-gray-600 uppercase font-bold">Nuevo Domicilio</label>
                            <input
                                className="py-2 px-3 w-full rounded border border-gray-600"
                                id="domicilio"
                                placeholder="Nuevo Domicilio"
                                type="text"
                                value={newDomicilio}
                                onChange={(e) => setNewDomicilio(e.target.value)}
                            />
                            <label htmlFor="observaciones" className="block text-gray-600 uppercase font-bold">Observaciones del Domicilio</label>
                            <input
                                className="py-2 px-3 w-full rounded border border-gray-600"
                                id="observaciones"
                                placeholder="Observaciones de Domicilio"
                                type="text"
                                value={newObservaciones}
                                onChange={(e) => setNewObservaciones(e.target.value)}
                            />
                            <button
                                type="button"
                                className={`w-1/2 sm:w-1/4 shadow-md p-3 mt-2 text-white transition-all uppercase font-bold rounded-lg ${newDomicilio!=='' ? 'bg-orange-500 hover:bg-orange-400':'bg-orange-200'}`}
                                onClick={() => saveDomicilio()}
                            >
                                Guardar
                            </button>

                        </div>

                    ) : (
                        <div className='flex'>
                            <button
                                type="button"
                                className="mx-auto p-3 md:ml-1 bg-blue-500 text-white text-center hover:bg-blue-400 transition-all uppercase font-bold rounded-lg flex"
                                onClick={() => setAddDomicilio(true)}
                            >
                                <FaPlus className='mt-1 mr-2' />
                                Agregar Nuevo Domicilio
                            </button>

                        </div>

                    )}
                </div>
                <div className="sm:items-start mt-5">
                </div>
                <div className="sm:items-start mt-5">
                    <label htmlFor="telefono" className="block text-gray-600 uppercase font-bold">Teléfono</label>
                    <input
                        className="py-2 px-3 w-full rounded border border-gray-600"
                        id="telefono"
                        placeholder="Ingrese Nº de Teléfono"
                        type="text"
                        value={formik.values.telefono}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                </div>
            </div>
            <div className="my-3">
                <div className="w-full rounded-lg px-3 flex justify-center">
                    <input
                        type="submit"
                        className="w-1/2 sm:w-1/4 shadow-md p-3 bg-indigo-600 text-gray-100 hover:bg-indigo-400 transition-all uppercase font-bold rounded-lg"
                        value="Guardar"
                    />

                    <button
                        type="button"
                        className="w-1/2 sm:w-1/4 shadow-md p-3 ml-3 bg-gray-500 text-white hover:bg-gray-400 transition-all uppercase font-bold rounded-lg"
                        onClick={() => { setViewOpen(false); setEditCliente(false) }}
                    >
                        Salir
                    </button>

                </div>
            </div>
        </form>
    )
}

export default FEditCliente